import { GameScene } from "../scenes/GameScene";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { BoundingBox } from "./LTGame";
import { Player } from "./Player";
import { PoolGameObject } from "./PoolGameObject";

export class Coin extends PoolGameObject {

	gameScene: GameScene;
	target?: Player;
	sprite: Phaser.GameObjects.Sprite;
	hitbox: Phaser.GameObjects.Image;
	speed = 10;
	collectable = true;
	animEvent: Phaser.Time.TimerEvent;
	
	constructor(scene: GameScene, x: number, y: number) {
		super(scene);
		this.gameScene = scene;
		const size = 20;

		const img = this.hitbox = this.addImage("whiteSquare");
		img.setDisplaySize(size, size);
		img.tint = 0xF6CF5B;
		img.alpha = 0;

		const sprite = this.sprite = this.scene.add.sprite(0, 0, "coin-sheet");
		sprite.play("coinIdle");
		this.add(sprite);

		this.addComponent(new DestroyOffscreen(this, true, false));
	}

	getHitbox(): BoundingBox<Coin> {
		const w = this.hitbox.displayWidth * 3;
		const h = this.hitbox.displayHeight * 3;

		return {
			minX: this.x - w, minY: this.y - h,
			maxX: this.x + w, maxY: this.y + h,
			obj: this,
		};
	}

	poolSetup(x: number, y: number, everyOther: number, collectable = true): void {
		this.target = undefined;

		this.x = x;
		this.y = y;

		this.collectable = collectable;

		this.animEvent = this.scene.time.addEvent({
			delay: everyOther * 500,
			callback: () => {
				// if (this.spine.skeletonData) this.spine.play("idle", true);
				if (this.sprite) this.sprite.play("coinIdle");
			}
		});
	}

	poolDestroy(): void {
		this.scene.time.removeEvent(this.animEvent);
	}

	onCollect(target: Player): void{
		if (!this.collectable) return;
		this.collectable = false;
		this.scene.soundManager.play("coinCollect", false, {volume: 0.7});
		if (this.sprite) {
			const anim = this.sprite.play("coinBurst");
			anim.once("animationcomplete", () => {
				target.collectCoin();
				this.destroy();
			});
		}
	}

	update(dt: number): void {
		super.update(dt);

		if (this.target) {
			const ang = Math.atan2(this.target.y - this.y, this.target.x - this.x);
			const px = this.x;
			const py = this.y;
			this.x += Math.cos(ang) * this.speed * dt;
			this.y += Math.sin(ang) * this.speed * dt;
			if (Math.sign(px - this.target.x) == -Math.sign(this.x - this.target.x)) {
				this.x = this.target.x;
			}
			if (Math.sign(py - this.target.y) == -Math.sign(this.y - this.target.y)) {
				this.y = this.target.y;
			}
			this.speed += 80 * dt;

			const dist = Phaser.Math.Distance.Between(this.target.x, this.target.y, this.x, this.y);
			if (dist < 50) {
				this.destroy();
				this.target.collectCoin();
			}
		}
	}

}